import { ISettingInfo, IWritableSettings } from "@barthauer/abc/core";

export enum MapFrameSetting {
  gridLayouts,
}

export interface IMapFrameSettings {
  readonly gridLayouts: {};
}

export class MapFrameSettings implements IMapFrameSettings, IWritableSettings<IMapFrameSettings> {
  public static readonly Infos: ReadonlyMap<MapFrameSetting, ISettingInfo> = new Map<MapFrameSetting, ISettingInfo>([
    [
      MapFrameSetting.gridLayouts,
      { settingName: 'gridLayouts', responsePropertyName: 'gridLayouts', settingValueType: Object },
    ],
  ]);

  gridLayouts: {} = {};

  load(settings: IMapFrameSettings): void {
    this.gridLayouts = settings?.gridLayouts ?? {};
  }
}
